import { Link } from "@quintype/components";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import User from "../../../../../atoms/other-icons/User";
import "./cok-signin-button.m.css";
import { pushEventToDataLayer } from "../../../../../helper/datalayer-utils";

function CokSigninButton() {
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const [redirectURL, setRedirectUrl] = useState("");
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    setRedirectUrl(window.location.href);
  }, []);

  const signinHandler = () => {
    if (window?.dataLayer) pushEventToDataLayer("SSO_Page_Open");

    window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectURL}`;
  };
  return (
    <div styleName="wrapper" onClick={signinHandler}>
      {isMobile ? (
        <Link styleName="signin-btn-only-icon" targer="_blank">
          <User color="#a5161c" width="10.31px" height="11.61px" />
        </Link>
      ) : (
        <Link styleName="signin-btn" targer="_blank">
          <User color="#a5161c" width="10.31px" height="11.61px" />
          Sign in
        </Link>
      )}
    </div>
  );
}

export default CokSigninButton;
